<template>
  <div class="special-note-section">
    <div class="special-note-header">
      <div class="special-note-title">
        特記事項
      </div>
      <div class="special-note-actions">
        <EditHistoryPopover :history="history" />
        <v-btn
          v-if="!isEditing"
          color="#3ACAC9"
          variant="outlined"
          size="small"
          style="background: white;"
          @click="$emit('edit')"
        >
          編集する
        </v-btn>
        <template v-else>
          <v-btn
            color="#3ACAC9"
            variant="flat"
            size="small"
            :disabled="isSaving"
            :loading="isSaving"
            @click="$emit('save')"
          >
            保存する
          </v-btn>
          <v-btn
            variant="outlined"
            size="small"
            :disabled="isSaving"
            @click="$emit('cancel')"
          >
            キャンセル
          </v-btn>
        </template>
      </div>
    </div>
    <v-textarea
      :model-value="specialNoteDraft"
      :readonly="!isEditing"
      rows="4"
      variant="outlined"
      hide-details
      bg-color="white"
      @update:model-value="$emit('update:specialNoteDraft', $event)"
    />
  </div>
</template>

<script>
import EditHistoryPopover from "@/vue/shared/ui/EditHistoryPopover.vue";

export default {
  name: "FaceSheetUserSpecialNoteSection",
  components: {
    EditHistoryPopover
  },
  props: {
    specialNoteDraft: {
      type: String,
      required: true
    },
    isEditing: {
      type: Boolean,
      default: false
    },
    // 保存処理中フラグ。true の間は保存ボタンを無効化し連打を防ぐ。
    isSaving: {
      type: Boolean,
      default: false
    },
    history: {
      type: Array,
      default: () => []
    }
  },
  emits: ["update:specialNoteDraft", "edit", "save", "cancel"]
};
</script>

<style lang="scss" scoped>
.special-note-section {
  margin-top: 16px;
}

.special-note-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 8px;
}

.special-note-title {
  font-weight: bold;
}

.special-note-actions {
  display: flex;
  gap: 8px;
}
</style>
